/**
 * Aufzählungen von Kontotypen
 */
export enum accountypeDefinitions {
    VGM = "Vermarktergemeinschaft",
    operator = "Administrator",
    member = "Mitglied"
}
